import * as z from 'zod';
import { schema as contactSchema } from '../../interfaces/contact-data';
import i18next from 'i18next';

const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/;

const passwordSchema = z
  .object({
    password: z.string().nonempty({ message: i18next.t('Password required') }).regex(
      passwordRegex,
      'The password must contain at least eight characters, at least one number, and both lower and uppercase letters, and special characters'
    ),
    confirm: z.string().nonempty({ message: i18next.t('Confirm password required') }).regex(
      passwordRegex,
      'The password must contain at least eight characters, at least one number, and both lower and uppercase letters, and special characters'
    ),
  })
  .refine((data) => data.password === data.confirm, {
    message: 'Passwords do not match',
    path: ['confirm'],
  });

const flagSchema = z.object({
  joinClub: z.boolean().default(false).optional(),
  acceptTerms: z
    .boolean()
    .default(false)
    .refine((x) => !!x, 'Please accept our terms'),
});

const schema = z.object({
  contact: contactSchema,
  password: passwordSchema,
  flags: flagSchema,
});

type AuthRegisterData = z.infer<typeof schema>;

export { schema, flagSchema };
export type { AuthRegisterData };
export default AuthRegisterData;
